module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-bg-1-60e92e7a71d83f918c37756569270dae.png";